<template>
    <div class="d-flex justify-space-between">

        <div class="ma-2 cursor-pointer align-self-center d-flex">

            <link-avatar :locale="locale"/>

            <v-icon class="ml-2" color="grey">mdi-link</v-icon>

            <v-tooltip top color="primary">
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="align-self-center ml-2" @click="copyClicked(appAddress)">
                        <span>{{ appAddress }}</span>
                    </div>
                </template>

                <span>Copy to clipboard</span>
            </v-tooltip>
        </div>

        <div class="text-no-wrap align-self-center mr-4">

            <v-tooltip top color="primary" open-delay="250">
                <template v-slot:activator="{ on }">

                    <v-btn class="mr-2" small v-on="on" icon @click="widgetButtonClicked(locale)">
                        <v-icon left color="white" class="ml-2">mdi-code-tags</v-icon>
                    </v-btn>
                </template>
                View instruction how to enable members app on your website.
            </v-tooltip>

            <v-tooltip top color="primary" open-delay="250">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small color="primary" @click="sendToUrl(appAddress,true)">
                        Login
                    </v-btn>
                </template>
                Open up the app login
            </v-tooltip>
        </div>

        <!-- WIDGET SETTINGS DIALOG -->
        <widget-settings-dialog v-model="widgetSettingsDialogModel"
                                :widget-url="widgetUrl"
        ></widget-settings-dialog>

    </div>
</template>

<script>

import Json from 'vue-json-pretty';
import WidgetSettingsDialog from "./WidgetSettingsDialog";
import {clipboardMixin} from "../../../components/mixins/clipboardMixin";
import LinkAvatar from "./LinkAvatar";

export default {

    mixins: [clipboardMixin],

    components: {
        LinkAvatar,
        WidgetSettingsDialog,
        Json
    },

    props: {
        subPanel: {
            required: true,
            type: Object
        },
        locale: {
            type: Object,
            required: false,
            default: null,
        },
    },

    computed: {

        appAddress() {
            let base = window.location.protocol + '//' + window.location.hostname + '/app/login/' + this.subPanel.id;
            if (this.locale) base += '/' + this.locale.code;
            return base;
        },
    },

    data() {
        return {
            widgetSettingsDialogModel: false,
            widgetUrl: null,
        }
    },

    methods: {

        copyClicked(url) {
            this.copyToClipboard(url);
            Bus.$emit('flash-message', {message: 'URL copied to clipboard!'});
        },

        widgetButtonClicked(locale) {
            this.widgetUrl = this.appAddress;
            this.widgetSettingsDialogModel = true;
        }
    }
}
</script>
